import styles from "./styles.module.scss";

const Section = ({ children, color = "#FBFBFB", display = true, style }) => {
  return (
    <div
      className={styles.wrapper}
      style={{ backgroundColor: color, ...(style || {}) }}
    >
      <div className={styles.container}>{children}</div>
    </div>
  );
};

export default Section;
